import React from 'react';
import { ArticleHeading1, ArticleHeading2, Button, Image, UIText1, useDeviceType } from '@cian/ui-kit';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';

import * as styles from './styles.css';

export const CallToActionCard: React.FC<{
  imageX1Src: string;
  imageX2Src: string;
  heading: string;
  description: string;
  buttonText: string;
  onClick(): void;
}> = props => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const HeadingComponent = isMobile ? ArticleHeading2 : ArticleHeading1;

  return (
    <div className={cn(styles['card'], styles[deviceType])}>
      <Image
        src={props.imageX1Src}
        sources={[
          {
            srcset: props.imageX2Src,
            media: X2_IMAGE_SIZE_MEDIA_QUERY,
          },
          { srcset: props.imageX1Src },
        ]}
        width={140}
        height={100}
        objectFit="contain"
        display="block"
        loading="lazy"
      />
      <div className={styles['heading']}>
        <HeadingComponent>{props.heading}</HeadingComponent>
      </div>
      <div className={styles['description']}>
        <UIText1>{props.description}</UIText1>
      </div>
      <Button onClick={props.onClick} size="L">
        {props.buttonText}
      </Button>
    </div>
  );
};
